import { ApolloLink } from "./ApolloLink.js";
export const execute = ApolloLink.execute;
//# sourceMappingURL=execute.js.map